import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Button } from "antd";
import { clearPartnerGuestSession } from "../../api/api";

interface Props {
  expiresAt: number; // epoch ms
  onExpire: () => void;
}

const formatRemaining = (ms: number) => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

/**
 * 협력 사이트(OCSPST) 게스트 열람 안내 배너 - 남은 시간 표시, 0이 되면 onExpire 호출
 */
const PartnerGuestBanner = ({ expiresAt, onExpire }: Props) => {
  const navigate = useNavigate();
  const [remaining, setRemaining] = useState<number>(expiresAt - Date.now());

  useEffect(() => {
    const timer = setInterval(() => {
      const next = expiresAt - Date.now();
      setRemaining(next);
      if (next <= 0) {
        clearInterval(timer);
        onExpire();
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [expiresAt]);

  const goTo = (path: string) => {
    clearPartnerGuestSession();
    navigate(path);
  };

  return (
    <Banner>
      <Message>
        소아고형암 온라인 자문시스템에서 연결된 <strong>게스트 열람</strong> 중입니다.
        <Remaining>남은 시간 {formatRemaining(remaining)}</Remaining>
      </Message>
      <Actions>
        <Button size="small" onClick={() => goTo("/login")}>
          로그인
        </Button>
        <Button size="small" type="primary" onClick={() => goTo("/signup")}>
          회원가입
        </Button>
      </Actions>
    </Banner>
  );
};

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 16px;
  margin-bottom: 12px;
  background-color: #e8f1fb;
  border: 1px solid #b6d0ee;
  border-radius: 8px;
  color: #1f3a5a;
  font-size: 0.9rem;
`;

const Message = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const Remaining = styled.span`
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: #3d6ea5;
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
`;

export default PartnerGuestBanner;
